import { PureComponent } from "react";
import componentStyles from "./video-carousel-item-component.scss";
import YoutubeVideoWithPosterComponent from "components/core/youtube-video-with-poster/youtube-video-with-poster-component";
import ColorfulTitleComponent from "/components/core/colorful-title/colorful-title-component";
import PictureComponent from "/components/core/picture/picture-component";

export default class VideoCarouselItemComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.onPlayButtonClicked = this.onPlayButtonClicked.bind(this);
  }

  onPlayButtonClicked() {
    const { onPlay, data } = this.props;
    onPlay(data.videoId, data.title);
  }

  render() {
    const { data, isMobile } = this.props;
    const screenRatios = { mobile: data.mobileImageWidthRatio };
    return (
      <div className="video-carousel-item-component">
        <div className="video-part">
          {data.videoId && isMobile ? (
            <div className="video-component-wrapper">
              <YoutubeVideoWithPosterComponent videoId={data.videoId} poster={data.poster} muted={false} volume={100} />
            </div>
          ) : (
            <div className="poster-image-wrapper" onClick={this.onPlayButtonClicked}>
              <PictureComponent pictureClass="poster-image" src={data.poster} screenRatios={screenRatios} />
              <div className="play-button-container">
                <div className="play-button" />
              </div>
            </div>
          )}
        </div>
        <ColorfulTitleComponent className="video-title" text={data.title} />
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
